export const RECENT_PROGRAMS_STORAGE_KEY = 'recent_programs';
export const RECENT_PROJECTS_STORAGE_KEY = 'recent_projects';
export const RECENT_PROGRAMS_STORAGE_EVENT = 'recent-program-storage';
export const RECENT_PROJECTS_STORAGE_EVENT = 'recent-project-storage';

const RECENT_HISTORY_OWNER_KEY = 'recent_history_owner';

/**
 * Binds the Recent menu's history to the person who is logged in.
 *
 * The history lives in localStorage, which outlives the session, so without this the next person to log in
 * on the same browser would see the previous person's recent programs and projects. History with a
 * different owner, or no recorded owner, is cleared.
 *
 * Must run before anything reads the history, which is why AppV2 calls it next to setPermissions.
 * Does nothing while nobody is logged in, so the history survives until the next person is known.
 */
export const claimRecentHistory = (personId: string | null | undefined): void => {
	if (personId == null) {
		return;
	}
	try {
		if (localStorage.getItem(RECENT_HISTORY_OWNER_KEY) === personId) {
			return;
		}
		localStorage.removeItem(RECENT_PROGRAMS_STORAGE_KEY);
		localStorage.removeItem(RECENT_PROJECTS_STORAGE_KEY);
		localStorage.setItem(RECENT_HISTORY_OWNER_KEY, personId);
	} catch (e) {
		return;
	}
	// Same deferred signal the recent hooks use, so any list that is already mounted re-reads its storage.
	setTimeout(() => {
		window.dispatchEvent(new Event(RECENT_PROGRAMS_STORAGE_EVENT));
		window.dispatchEvent(new Event(RECENT_PROJECTS_STORAGE_EVENT));
	}, 0);
};
